import React from 'react';
import logo from '../../assets/logo-color.png';

const EMPRESA = {
  nombre: 'Transportes Leo',
  direccion: 'Calle Balmaceda, Rawson, San Juan, Argentina',
  telefono: '264-489-2393',
  email: 'contacto@transporteleo.com.ar',
  web: 'www.transporteleo.com.ar',
};

function formatMoney(value) {
  const num = parseFloat(value) || 0;
  return num.toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  });
}

function formatDate(dateStr) {
  if (!dateStr) return '-';
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}

const CotizadorPreview = React.forwardRef(function CotizadorPreview({ data, mode = 'screen' }, ref) {
  const {
    numPresupuesto = '',
    fecha = '',
    clienteNombre = '',
    clienteTelefono = '',
    clienteEmail = '',
    origen = '',
    destino = '',
    fechaSalida = '',
    fechaRegreso = '',
    cantPasajeros = '',
    tipoServicio = '',
    descripcion = '',
    precioBase = 0,
    adicionales = 0,
    descuento = 0,
    observaciones = '',
    validezPresupuesto = '',
  } = data || {};

  const base = parseFloat(precioBase) || 0;
  const adic = parseFloat(adicionales) || 0;
  const desc = parseFloat(descuento) || 0;
  const total = base + adic - desc;
  const documentClassName = `cotizador-preview-document cotizador-preview-document--${mode}`;

  return (
    <div
      ref={ref}
      className={documentClassName}
      style={{
        background: '#fff',
        width: '794px',
        minHeight: '1000px',
        padding: '40px 48px',
        fontFamily: 'Arial, sans-serif',
        fontSize: '13px',
        color: '#222',
        boxSizing: 'border-box',
      }}
    >
      {/* ENCABEZADO */}
      <div className="cotizador-preview-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
        <div className="cotizador-preview-logo-wrap" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img src={logo} alt="Transportes Leo" style={{ width: '160px', objectFit: 'contain' }} />
        </div>
        <div className="cotizador-preview-heading" style={{ textAlign: 'right' }}>
          <div style={{
            fontSize: '22px',
            fontWeight: '900',
            color: 'rgb(133, 15, 15)',
            letterSpacing: '2px',
            marginBottom: '4px',
          }}>
            PRESUPUESTO
          </div>
          <div style={{ fontSize: '15px', fontWeight: '700', color: '#333' }}>
            N° {numPresupuesto || '—'}
          </div>
          <div style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>
            Fecha: {formatDate(fecha)}
          </div>
        </div>
      </div>

      {/* DATOS EMPRESA */}
      <div className="cotizador-preview-company" style={{
        background: 'rgb(133, 15, 15)',
        color: '#fff',
        padding: '10px 16px',
        borderRadius: '4px',
        marginBottom: '20px',
        fontSize: '12px',
      }}>
        <div style={{ fontWeight: '700', fontSize: '14px', marginBottom: '3px' }}>{EMPRESA.nombre}</div>
        <div>{EMPRESA.direccion} · Tel: {EMPRESA.telefono} · {EMPRESA.email}</div>
      </div>

      {/* CLIENTE + VIAJE */}
      <div className="cotizador-preview-summary" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
        <div className="cotizador-preview-card" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '14px' }}>
          <div style={{ fontWeight: '800', fontSize: '11px', color: 'rgb(133, 15, 15)', letterSpacing: '1px', marginBottom: '10px', textTransform: 'uppercase' }}>
            Datos del cliente
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <tbody>
              <tr><td style={{ paddingBottom: '4px', color: '#666', width: '40%' }}>Nombre</td><td style={{ paddingBottom: '4px', fontWeight: '600' }}>{clienteNombre || '—'}</td></tr>
              <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Teléfono</td><td style={{ paddingBottom: '4px' }}>{clienteTelefono || '—'}</td></tr>
              {clienteEmail && (
                <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Email</td><td style={{ paddingBottom: '4px' }}>{clienteEmail}</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="cotizador-preview-card" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '14px' }}>
          <div style={{ fontWeight: '800', fontSize: '11px', color: 'rgb(133, 15, 15)', letterSpacing: '1px', marginBottom: '10px', textTransform: 'uppercase' }}>
            Detalle del viaje
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <tbody>
              <tr><td style={{ paddingBottom: '4px', color: '#666', width: '40%' }}>Tipo</td><td style={{ paddingBottom: '4px', fontWeight: '600' }}>{tipoServicio || '—'}</td></tr>
              <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Origen</td><td style={{ paddingBottom: '4px' }}>{origen || '—'}</td></tr>
              <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Destino</td><td style={{ paddingBottom: '4px' }}>{destino || '—'}</td></tr>
              <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Salida</td><td style={{ paddingBottom: '4px' }}>{formatDate(fechaSalida)}</td></tr>
              {fechaRegreso && (
                <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Regreso</td><td style={{ paddingBottom: '4px' }}>{formatDate(fechaRegreso)}</td></tr>
              )}
              <tr><td style={{ paddingBottom: '4px', color: '#666' }}>Pasajeros</td><td style={{ paddingBottom: '4px' }}>{cantPasajeros || '—'}</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* DESCRIPCIÓN */}
      {descripcion && (
        <div className="cotizador-preview-card cotizador-preview-text-block" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '14px', marginBottom: '20px' }}>
          <div style={{ fontWeight: '800', fontSize: '11px', color: 'rgb(133, 15, 15)', letterSpacing: '1px', marginBottom: '8px', textTransform: 'uppercase' }}>
            Descripción del servicio
          </div>
          <p style={{ fontSize: '12px', lineHeight: '1.6', color: '#333' }}>{descripcion}</p>
        </div>
      )}

      {/* TABLA DE IMPORTES */}
      <div className="cotizador-preview-amounts" style={{ marginBottom: '20px' }}>
        <div style={{ fontWeight: '800', fontSize: '11px', color: 'rgb(133, 15, 15)', letterSpacing: '1px', marginBottom: '8px', textTransform: 'uppercase' }}>
          Detalle de importes
        </div>
        <table className="cotizador-preview-amounts-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th style={{ textAlign: 'left', padding: '8px 12px', border: '1px solid #ddd', fontWeight: '700' }}>Concepto</th>
              <th style={{ textAlign: 'right', padding: '8px 12px', border: '1px solid #ddd', fontWeight: '700', width: '180px' }}>Importe</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '8px 12px', border: '1px solid #ddd' }}>Precio base del servicio</td>
              <td style={{ padding: '8px 12px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(base)}</td>
            </tr>
            {adic > 0 && (
              <tr>
                <td style={{ padding: '8px 12px', border: '1px solid #ddd' }}>Adicionales</td>
                <td style={{ padding: '8px 12px', border: '1px solid #ddd', textAlign: 'right' }}>+ {formatMoney(adic)}</td>
              </tr>
            )}
            {desc > 0 && (
              <tr>
                <td style={{ padding: '8px 12px', border: '1px solid #ddd' }}>Descuento</td>
                <td style={{ padding: '8px 12px', border: '1px solid #ddd', textAlign: 'right', color: 'rgb(133, 15, 15)' }}>- {formatMoney(desc)}</td>
              </tr>
            )}
            <tr style={{ background: 'rgb(133, 15, 15)' }}>
              <td style={{ padding: '10px 12px', border: '1px solid rgb(133, 15, 15)', fontWeight: '800', color: '#fff', fontSize: '14px' }}>TOTAL</td>
              <td style={{ padding: '10px 12px', border: '1px solid rgb(133, 15, 15)', textAlign: 'right', fontWeight: '900', color: '#fff', fontSize: '16px' }}>{formatMoney(total)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* OBSERVACIONES */}
      {observaciones && (
        <div className="cotizador-preview-card cotizador-preview-text-block" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '14px', marginBottom: '20px' }}>
          <div style={{ fontWeight: '800', fontSize: '11px', color: 'rgb(133, 15, 15)', letterSpacing: '1px', marginBottom: '8px', textTransform: 'uppercase' }}>
            Observaciones
          </div>
          <p style={{ fontSize: '12px', lineHeight: '1.6', color: '#333' }}>{observaciones}</p>
        </div>
      )}

      {/* PIE */}
      <div className="cotizador-preview-footer" style={{
        borderTop: '2px solid rgb(133, 15, 15)',
        paddingTop: '14px',
        marginTop: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        fontSize: '11px',
        color: '#555',
      }}>
        <div>
          {validezPresupuesto && (
            <div><strong>Validez:</strong> {validezPresupuesto}</div>
          )}
          <div style={{ marginTop: '4px', color: '#888' }}>
            Este presupuesto es informativo. Los precios pueden estar sujetos a modificaciones.
          </div>
        </div>
        <div style={{ textAlign: 'right', color: 'rgb(133, 15, 15)', fontWeight: '700' }}>
          <div>Transportes Leo</div>
          <div style={{ fontWeight: '400', color: '#888' }}>Conectando destinos</div>
        </div>
      </div>
    </div>
  );
});

export default CotizadorPreview;
